import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { actionsComponent } from './actions.component';
import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DossierHeaderModule } from '../dossiers/components/dossierHeader.module';
import { SubHeaderModule } from '../components/common/sub-header/sub-header.module';
import { ConfirmationService } from 'primeng-lts/api';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { AccordionModule } from 'primeng-lts/accordion';
import { DialogModule } from 'primeng-lts/dialog';
import { TableModule } from 'primeng-lts/table';

@NgModule({
  declarations: [actionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AccordionModule,
    DialogModule,
    WaitLoadingModule,
    DynamicDialogModule,
    TranslateModule,
    ConfirmDialogModule,
    DossierHeaderModule,
    PanelModule,
    ScrollPanelModule,
    SubHeaderModule,
    TableModule
  ],
  providers: [ConfirmationService]
})
export class ActionsModule { }
